interface Props {
  provider: {
    id: string
    first_name: string
    last_name_initial: string
    clinical_role: string
    title: string
    locations: { city: string; us_state: string; location_type: string }[]
    licenses: { us_state: string; license_type: string; status: string }[]
  }
  unlocked: boolean
  phones?: { number: string; phone_type: string }[]
  emails?: { email: string; email_type: string }[]
}

export default function ProviderShow({ provider, unlocked, phones, emails }: Props) {
  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">
        {provider.first_name} {provider.last_name_initial}
      </h1>
      {/* TODO: full profile layout, unlock button, contact info */}
      <pre className="text-xs bg-muted p-4 rounded-md overflow-auto">
        {JSON.stringify({ provider, unlocked, phones, emails }, null, 2)}
      </pre>
    </div>
  )
}
